import React from 'react';
import moment from 'moment';
import { Row, Col, Container } from 'reactstrap';
import { connect } from 'react-redux';
import { Paper, RaisedButton, FontIcon, AutoComplete, List, ListItem, Divider, Tab, Tabs } from 'material-ui';

import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import { FORM_MENSAJE } from 'modules/forms/formConstants';
import { TextFieldF, DatePickerF, CheckBoxFieldF, AutoCompleteF } from 'modules/forms/component';
import * as validations from 'modules/forms/validations';

const selector = formValueSelector(FORM_MENSAJE);
import * as mensajesActions from 'modules/mensajes/action';
import * as generalActions from 'modules/general/action';
import * as viajesActions from 'modules/viajes/action';
import * as abonadosActions from 'modules/abonados/action';
import { CancelarButtonC } from 'modules/general/component';
import CheckListViajes from './checkListViajes';
import { checkPermissions } from 'core/generalFunctions';

@connect((store) => ({
  viajes: store.get('viajes'),
  globalBool: selector(store, 'globalBool') || false,
  toUser: selector(store, 'toUser') || false,
  usuariosList: store.getIn(['abonados', 'lista', 0]),
  abonadosList: store.getIn(['abonados', 'lista', 1]),
  usuarioId: selector(store, 'usuarioId'),
  mensajesList: store.getIn(['mensajes', 'listaUsuario']),
  loading: store.getIn(['general', 'loading']),
}))
class Add extends React.Component {
  componentDidMount() {
    const { dispatch, viajes } = this.props;
    dispatch(generalActions.dashboard_changeTitle('NUEVO MENSAJE'));
    viajes.get('hoy').size == 0 && viajes.get('manana').size == 0 && dispatch(viajesActions.get());
  }
  componentWillUnmount = () => this.props.dispatch(mensajesActions.clear('all'));
  componentDidUpdate = (prevProps) => {
    if (this.props.toUser && this.props.usuarioId && prevProps.usuarioId != this.props.usuarioId) {
      this.props.dispatch(mensajesActions.getUsuario(this.props.usuarioId));
    }
  };
  submitForm = (data) => {
    if (data.get('toUser')) {
      this.props.dispatch(mensajesActions.setUsuario(data.get('mensaje'), data.get('usuarioId'), data.get('fechaCaducidad')));
    } else {
      data = formatData(data.toJS());
      this.props.dispatch(mensajesActions.set(data));
    }
  };
  findUser = (query, lista, { source }) => {
    if (source == 'change' && query && query.length > 2 && lista && !lista.find((usuario) => usuario && usuario.fullName && usuario.fullName.toLowerCase().search(query) == 0)) {
      this.props.dispatch(abonadosActions.get(query));
    }
  };
  render() {
    const { invalid, globalBool, toUser, mensajesList, loading } = this.props;
    let { usuariosList, abonadosList } = this.props;
    usuariosList ? (usuariosList = usuariosList.map((u) => u.set('fullName', `${u.get('nombre')} ${u.get('apellido')} - ${u.get('documento')}`)).toJS()) : (usuariosList = []);
    abonadosList ? (abonadosList = abonadosList.map((u) => u.set('fullName', `${u.get('nombre')} ${u.get('apellido')} - ${u.get('documento')}`)).toJS()) : (abonadosList = []);
    return (
      <Container fluid={true}>
        <Row>
          <Col md={{ size: 10, offset: 1 }}>
            <Paper zDepth={2} className="container">
              <form>
                <Row className="rowContainer">
                  <Col md="6" className="alignStart">
                    <Row>
                      <Col md="12">
                        <Field
                          name={'mensaje'}
                          component={TextFieldF}
                          inputProps={{
                            hintText: 'Mensaje',
                            floatingLabelText: 'Ingrese el mensaje',
                            className: 'capitalize',
                            fullWidth: true,
                            autoFocus: true,
                            multiLine: true,
                            rows: 2,
                          }}
                          validate={[validations.required, validations.minLength3]}
                        />
                      </Col>
                      {!toUser && (
                        <Col md="5" className="pt-30">
                          <Field
                            name="globalBool"
                            inputProps={{
                              label: 'Para todos',
                            }}
                            component={CheckBoxFieldF}
                          />
                        </Col>
                      )}
                      <Col md="6">
                        <Row>
                          <Col md="1" className="pt-30">
                            <FontIcon className="fa fa-calendar-times-o" />
                          </Col>
                          <Col md="9">
                            <Field
                              name="fechaCaducidad"
                              component={DatePickerF}
                              format={(value) => (typeof value == 'string' ? null : value)}
                              inputProps={{
                                autoOk: true,
                                hintText: 'Hasta que fecha se muestra',
                                floatingLabelText: 'Hasta que fecha se muestra',
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md="8" className="pt-30">
                        <Field
                          name="toUser"
                          inputProps={{
                            label: 'Para un usuario',
                          }}
                          component={CheckBoxFieldF}
                        />
                      </Col>
                      {toUser && (
                        <Col md="8">
                          <Field
                            name="usuarioId"
                            component={AutoCompleteF}
                            inputProps={{
                              fullWidth: true,
                              dataSource: usuariosList.concat(abonadosList),
                              dataSourceConfig: { text: 'fullName', value: 'id' },
                              filter: AutoComplete.caseInsensitiveFilter,
                              hintText: 'Nombre de usuario',
                              onUpdateInput: (value, lista, source) => this.findUser(value, lista, source),
                              openOnFocus: true,
                            }}
                            onBlur={(e) => e.preventDefault()}
                            validate={[validations.required, validations.noObject]}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col md="6" className="alignStart">
                    {toUser && (
                      <Row>
                        <Col>
                          <Tabs>
                            <Tab label="Mensajes enviados">
                              <List className="noPadding dividerList">
                                {mensajesList.map((mensaje) => (
                                  <Row key={mensaje.get('id')}>
                                    <Col>
                                      <ListItem
                                        primaryText={`${moment(mensaje.get('fechaEmision')).format('DD/MM/YY HH:mm')}hs`}
                                        secondaryText={<p>{mensaje.get('mensaje')}</p>}
                                        secondaryTextLines={2}
                                      />
                                    </Col>
                                    <Col>
                                      <Divider />
                                    </Col>
                                  </Row>
                                ))}
                              </List>
                            </Tab>
                          </Tabs>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      {!globalBool && !toUser && (
                        <Col md="6" className="alignStart">
                          <Paper zDepth={1}>
                            <CheckListViajes diaViaje="hoy" />
                          </Paper>
                        </Col>
                      )}
                      {!globalBool && !toUser && (
                        <Col md="6" className="alignStart">
                          <Paper zDepth={1}>
                            <CheckListViajes diaViaje="manana" />
                          </Paper>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col md="12">
                    <RaisedButton
                      onClick={this.props.handleSubmit(this.submitForm)}
                      label="GUARDAR"
                      primary={true}
                      disabled={!checkPermissions(['admin', 'administrador_mensajes']) || invalid || loading}
                      className="fullWidthComponent noPadding m-tb-20"
                    />
                  </Col>
                </Row>
              </form>
            </Paper>
          </Col>
        </Row>
        {typeof this.props.isPopup === 'function' ? null : <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />}
      </Container>
    );
  }
}

const formatData = (data) => {
  let viajes = [],
    dataClon = Object.assign({}, data);

  if (data.viajes && !dataClon.globalBool) {
    Object.keys(data.viajes).forEach((key) => data.viajes[key] && viajes.push(key));
    dataClon.viajes = viajes;
  } else delete dataClon.viajes;

  if (dataClon.fechaCaducidad) dataClon.fechaCaducidad = moment(data.fechaCaducidad).format();
  if (!dataClon.globalBool) dataClon.globalBool = false;
  return dataClon;
};

export default reduxForm({
  form: FORM_MENSAJE,
  enableReinitialize: true,
})(Add);



// WEBPACK FOOTER //
// src/modules/mensajes/components/add.js